// extracted by mini-css-extract-plugin
export default {"innerWrapper":"xu-z","tooltipWrapper":"yu-z","icon":"zu-z","tooltip":"Au-z","content":"Bu-z"};